import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonComponent, InputComponent } from '../ui';

interface Message {
  id: string;
  from: string;
  fromName: string;
  subject: string;
  message: string;
  date: Date;
  read: boolean;
  type: 'appointment' | 'prescription' | 'billing' | 'general';
}

@Component({
  selector: 'app-messages',
  imports: [CommonModule, FormsModule, ButtonComponent, InputComponent],
  templateUrl: './messages.component.html',
  styleUrl: './messages.component.css'
})
export class MessagesComponent {
  messages = signal<Message[]>([
    {
      id: '1',
      from: 'patient1',
      fromName: 'Alice Johnson',
      subject: 'Appointment Reminder',
      message: 'Hello, I would like to confirm my appointment scheduled for tomorrow at 10 AM.',
      date: new Date(),
      read: false,
      type: 'appointment'
    },
    {
      id: '2',
      from: 'patient2',
      fromName: 'Bob Smith',
      subject: 'Prescription Refill Request',
      message: 'I need a refill for my medication. Please let me know when it will be ready.',
      date: new Date(Date.now() - 3600000),
      read: false,
      type: 'prescription'
    },
    {
      id: '3',
      from: 'system',
      fromName: 'System',
      subject: 'Bill Payment Reminder',
      message: 'Reminder: Bill BL-2024-001 is due in 3 days.',
      date: new Date(Date.now() - 7200000),
      read: true,
      type: 'billing'
    }
  ]);

  selectedMessage = signal<Message | null>(null);
  searchQuery = signal('');

  filteredMessages = signal<Message[]>([]);

  constructor() {
    this.updateFilteredMessages();
  }

  updateFilteredMessages() {
    const query = this.searchQuery().toLowerCase();
    if (!query) {
      this.filteredMessages.set(this.messages());
    } else {
      this.filteredMessages.set(
        this.messages().filter(m =>
          m.subject.toLowerCase().includes(query) ||
          m.fromName.toLowerCase().includes(query) ||
          m.message.toLowerCase().includes(query)
        )
      );
    }
  }

  onSearchChange(query: string) {
    this.searchQuery.set(query);
    this.updateFilteredMessages();
  }

  selectMessage(message: Message) {
    this.selectedMessage.set(message);
    if (!message.read) {
      this.messages.update(msgs =>
        msgs.map(m => m.id === message.id ? { ...m, read: true } : m)
      );
    }
  }

  getUnreadCount() {
    return this.messages().filter(m => !m.read).length;
  }
}

